export default __webpack_public_path__ + "static/1221-2ff9d65fa429515c267c6a2a548eb424.gif";